import moment from 'moment';

var walkIcon = {
  path: 'M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7',
  fillColor: '#E5332A',
  fillOpacity: 1,
  scale: 2,
  strokeWeight: 0,
  anchor: new google.maps.Point(18, 18)
};
var driveIcon = {
  path: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z',
  fillColor: '#E5332A',
  fillOpacity: 1,
  scale: 1.5,
  strokeColor: 'black',
  strokeWeight: 1,
  anchor: new google.maps.Point(12, 12),
  labelOrigin: new google.maps.Point(5, -5)
};

function driver (key, data, map) {
  console.log('new driver: ', data);
  this.text = key;
  this.driver = key;

  try {
    this.pos = {
      latitude: data[key].l && data[key].l[0] || 0,
      longitude: data[key].l && data[key].l[1] || 0
    }
    this.position = new google.maps.LatLng(this.pos.latitude, this.pos.longitude)
    this.data = data[key].data || null;
    this.battery = data.battery || null;
    this.marker = null
    this.onDestination = false;
    this.bookings = [];
    this.infoWindow = new google.maps.InfoWindow({ disableAutoPan: true, shouldFocus: false  });
    this.labelWindow = new google.maps.InfoWindow({ disableAutoPan: true, shouldFocus: false  });
    this.setMarker(map);
    this.setOnClick();
    this.emitter = window.vue.$bus;
  } catch (error) {
    console.log('driver error: ', data);
  }
}

driver.prototype.addMarker = function (map) {
  this.marker.setMap(map);
}

driver.prototype.removeMarker = function () {
  this.marker.setMap(null);
}

driver.prototype.setMarker = function (map) {
  var icon = (this.data && this.data.position && this.data.position.activity && this.data.position.activity.type === 'on_foot') ? walkIcon : driveIcon;
  this.marker = new google.maps.Marker({
    title: 'driver',
    labelContent: this.driver,
    position: new google.maps.LatLng(this.pos.latitude, this.pos.longitude),
    data: this.data || null
  });

  icon = Object.assign({}, icon);
  icon.fillColor = (this.data && this.data.charged) ? '#00CC00' : driveIcon.fillColor;
  this.marker.setIcon(icon);
  this.marker.setMap(map);

  this.updateInfo();
  return this.marker;
}
driver.prototype.setOnClick = function () {
  const that = this;
  google.maps.event.addListener(this.marker, 'click', function () {
    that.getBookings().then((result) => {
      that.emitter.$emit('driverTrips', result);
    });
  });
}

driver.prototype.checkGeofences = function (markers) {
  // var position = new google.maps.LatLng(this.pos.latitude, this.pos.longitude);
  ['client', 'destination', 'carecenter'].forEach((i) => {
    var data = markers[i];
    var targets = [];
    if (data.length) {
      data.forEach(coord => {
        if (coord.fence.getBounds().contains(this.position)) {
          targets.push(coord.data);
          if (!this.onDestination) {
            this.onDestination = true;
            // console.log(coord.data || (coord.data.firstname + ' ' + coord.data.lastname));
          }
        }
      })
    }
    if (targets.length === 0) {
      this.onDestination = false;
    }
  })
}

driver.prototype.getBookings = function (id) {
  var ap_date = new Date().toISOString().substr(0, 10);
  var results = [];
  var that = this;

  return new Promise((resolve, reject) => {
    if (that.data) {
      window.api
        .post('service/driver/byname/' + that.data.driverId, {ap_date})
        .then(response => {
          that.bookings = [];
          results = response.data || [];
          results.map(function (d) {
            var distance = JSON.parse(d.distance)
            that.bookings.push({
              id: d.id,
              charged: d.charged,
              driver: {
                id: d.driverId,
                name: d.driver_lastname,
              },
              client: {
                id: d.clientId,
                name:d.client_firstname + ' ' + d.client_lastname,
                pos: {
                  latitude: d.client_lat,
                  longitude : d.client_long
                }
              },
              destination: {
                id: d.destinationId,
                name: d.destination_name,
                pos: {
                  latitude: d.destination_lat,
                  longitude : d.destination_long
                }
              },
              ap_time: d.ap_time,
              pickTime: d.pick_time,
              type: d.type,
              distance
            });
          });
          resolve(that.bookings);
        })
        .catch(function (error) {
          console.log('catch:', error);
          reject(error)
        });
      } else {
        reject();
      }

  });
},

driver.prototype.update = function (driver) {
  console.log('update driver: ', driver);
  // get new position
  this.pos = {
    latitude: driver.l[0],
    longitude: driver.l[1]
  }
  this.position = new google.maps.LatLng(this.pos.latitude, this.pos.longitude)
  if (!this.marker || !this.marker.map) return
  var mapBounds = this.marker.map.getBounds();
  if (mapBounds.contains(this.position)) { // Check if position in map bounds, is visible

    this.data = driver.data || null;
    // this.data.position = driver.data.position;
    this.battery = driver.battery || null;

    // icon
    var icon = (this.data && this.data.position && this.data.position.activity && this.data.position.activity.type === 'on_foot') ? walkIcon : driveIcon;
    icon = Object.assign({}, icon);
    icon.fillColor = (this.data && this.data.charged) ? '#00CC00' : driveIcon.fillColor;
    this.marker.setIcon(icon);

    // set position on map and update info
    this.marker.setPosition(this.position);
    this.updateInfo();

  } else {
    this.marker.setPosition(this.position);
    console.log('not in bounds: ', this.driver);
  }
}

driver.prototype.updateInfo = function () {
  var battery = null;
  var markerContent = ''
  var markerLabel = ''
  var coord = this;

  if (coord.data && coord.data.position) {
    var speed = coord.data.position.coords.speed;
    speed = (speed && speed > 1) ? Math.floor(speed * 3.6) : 0;

    markerContent = '<span style="color: #E5332A"><strong>' + coord.driver + '</span>';
    if (speed > 0) {
      markerContent += '<br> <strong>Speed: </strong> ' + speed + ' km/h';
    }
    markerLabel = markerContent;
    if (coord.data.position.activity) {
      markerContent += '<br> <strong>Activity: </strong> ' + coord.data.position.activity.type;
    }
    if (coord.data.time) {
      markerContent += '<br> <strong>Time: </strong> ' + moment(coord.data.time).format('DD-MM-YY HH:mm');
    }
    if (coord.data.position.battery || coord.battery) {
      battery = coord.battery || coord.data.position.battery;
      markerContent += '<br> <strong>Battery: </strong> ' + parseInt(battery.level * 100) + '%';
      markerContent += '<br> <strong>isCharging: </strong> ' + battery.is_charging;
    }
    // infoWindow.open(this.map, marker);
    this.infoWindow.setContent(markerContent);
  } else {
    markerContent = '<span style="color: #E5332A"><strong>' + coord.driver + '</span>';
    markerLabel = markerContent;
  }
  this.labelWindow.setContent(markerLabel);
  if (!this.labelWindow.opened) {
    this.labelWindow.open(this.marker.map, this.marker);
    this.labelWindow.opened = true;
  }
}

export default driver
